import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpService from "../../services/httpService";
import { notify } from "../utils/methods/notification";
import HospitalApi from "../../services/hospitalService";
import { fetchAllCountry } from "./country";


const initialState = {
    isLoading: false,
    allCity: [],
    addModal: false,
    allStates:[],
    allCountries: [],
};
export const fetchAllCity = createAsyncThunk(
    'bmr/fetchAllCity',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await httpService.get('/getAllCities', { params: payload });
            return response;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
export const addCity = createAsyncThunk(
    'bmr/addCity',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const response = await httpService.post('/addcity', args);
            notify.success(response?.data?.message || response?.message || "City added successfully");
            dispatch(disableAddModal());
            dispatch(fetchAllCity({ page: 1, per_page: 10 }));
            return response.data;
        } catch (error) {
             notify.error(error || "Something went wrong");
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
export const deleteCity = createAsyncThunk(
    'bmr/deleteCity',
    async (args, { rejectWithValue }) => {
        try {
            const { id } = args;
            const response = await httpService.delete(`/deletecity/${id}`);
            notify.success(response?.data?.message || "City deleted successfully");
            return response.data;
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Something went wrong";
            notify.error(message);
            return rejectWithValue(message);
        }
    }
);
//@info this is for state list in modal 
export const fetchAllStates = createAsyncThunk(
    'bmr/fetchAllStates',
    async (countryId, { rejectWithValue }) => {
        try {
            const response = await HospitalApi.getAllState(countryId);
            return response;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
export const fetchAllCountries = createAsyncThunk(
    'bmr/fetchAllCountries',
    async (_, { rejectWithValue }) => {
        try {
            const response = await HospitalApi.getAllCountry();
            return response;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
export const updateCity = createAsyncThunk(
    'city/updateCity',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { editId, data } = args;
            const response = await httpService.put(`/updateCity/${editId}`, data);
            notify.success(response?.data?.message || response?.message || "City updated successfully");
                dispatch(disableAddModal());
            dispatch(fetchAllCity({ page: 1, per_page: 10 }));
            return response.data;
        } catch (error) {
            notify.error(error || "Something went wrong");
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
const bmrCitySlice = createSlice({
    name: 'bmrCity',
    initialState,
    reducers: {
        enableAddModal(state) {
            state.addModal = true
        },
        disableAddModal(state) {
            state.addModal = false
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllCity.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllCity.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allCity=action.payload
            })
            .addCase(fetchAllCity.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteCity.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteCity.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteCity.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(fetchAllStates.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllStates.fulfilled, (state,action) => {
                state.isLoading = false;
                 state.allStates = action.payload?.data?.states ?? [];
            })
            .addCase(fetchAllStates.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(fetchAllCountries.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllCountries.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allCountries = action.payload?.data?.countries ?? [];
            })
            .addCase(fetchAllCountries.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(updateCity.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateCity.fulfilled, (state, action) => {
                state.isLoading = false;
                if (state.currentCity?.id === action.payload.id) {
                    state.currentCity = action.payload;
                }
            })
            .addCase(updateCity.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(addCity.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(addCity.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(addCity.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(fetchAllCountry.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllCountry.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allCountries = action.payload?.data ?? [];
            })
            .addCase(fetchAllCountry.rejected, (state) => {
                state.isLoading = false;
            })
    }
})
export const { enableAddModal, disableAddModal } = bmrCitySlice.actions;
export default bmrCitySlice.reducer;